import { useQuery, useQueryClient, UseQueryResult } from "react-query";
import { ChatHttpService } from "../services";

interface ChatMessagesListProps {
  size?: number;
  conversationId?: string;
}

type ChatMessagesData = any; 

function useChatMessagesList({ conversationId, size = 30 }: ChatMessagesListProps): UseQueryResult<ChatMessagesData, unknown> {
  const queryClient = useQueryClient();

  const queryResult = useQuery<ChatMessagesData, unknown>(
    ["messages_list", conversationId],
    () => ChatHttpService.loadMessages({ conversationId }),
    {
      onSuccess: (data) => {
        // console.log(data);
      },
    }
  );

  return queryResult.data ? queryResult.data : queryResult;
}

export default useChatMessagesList;
